import { gql } from '@apollo/client'

export const GET_LOT_IMAGES_WITH_ID = gql`
    query booking_get_lot_image_urls($lot_id: String!) {
        booking_get_lot_image_urls(lot_id: $lot_id) {
            primary_url
            secondary_urls
        }
    }
`
